var map = {
	"./belt/belt-000000.svg": 45487,
	"./belt/belt-36873E.svg": 36965,
	"./belt/belt-3E7DB5.svg": 57148,
	"./belt/belt-572509.svg": 95434,
	"./belt/belt-6F5374.svg": 52855,
	"./belt/belt-C43418.svg": 69431,
	"./belt/belt-FEE12B.svg": 54867,
	"./belt/belt-FFFFFF.svg": 5270,
	"./eight/eight-000000.svg": 27222,
	"./eight/eight-36873E.svg": 12654,
	"./eight/eight-3E7DB5.svg": 19648,
	"./eight/eight-572509.svg": 33476,
	"./eight/eight-6F5374.svg": 7721,
	"./eight/eight-C43418.svg": 96938,
	"./eight/eight-FEE12B.svg": 92052,
	"./eight/eight-FFFFFF.svg": 26140,
	"./five/five-000000.svg": 99026,
	"./five/five-36873E.svg": 23472,
	"./five/five-3E7DB5.svg": 53074,
	"./five/five-572509.svg": 19759,
	"./five/five-6F5374.svg": 49403,
	"./five/five-C43418.svg": 15162,
	"./five/five-FEE12B.svg": 51841,
	"./five/five-FFFFFF.svg": 33559,
	"./four/four-000000.svg": 16000,
	"./four/four-36873E.svg": 85428,
	"./four/four-3E7DB5.svg": 8941,
	"./four/four-572509.svg": 66718,
	"./four/four-6F5374.svg": 48941,
	"./four/four-C43418.svg": 36277,
	"./four/four-FEE12B.svg": 43880,
	"./four/four-FFFFFF.svg": 87721,
	"./gym/gym-000000.svg": 13843,
	"./gym/gym-36873E.svg": 35410,
	"./gym/gym-3E7DB5.svg": 73324,
	"./gym/gym-572509.svg": 14323,
	"./gym/gym-6F5374.svg": 72657,
	"./gym/gym-C43418.svg": 67517,
	"./gym/gym-FEE12B.svg": 11729,
	"./gym/gym-FFFFFF.svg": 52084,
	"./nine/nine-000000.svg": 47758,
	"./nine/nine-36873E.svg": 10463,
	"./nine/nine-3E7DB5.svg": 69440,
	"./nine/nine-572509.svg": 84542,
	"./nine/nine-6F5374.svg": 45402,
	"./nine/nine-C43418.svg": 91911,
	"./nine/nine-FEE12B.svg": 28277,
	"./nine/nine-FFFFFF.svg": 46863,
	"./one/one-000000.svg": 12126,
	"./one/one-36873E.svg": 40845,
	"./one/one-3E7DB5.svg": 37589,
	"./one/one-572509.svg": 98519,
	"./one/one-6F5374.svg": 7958,
	"./one/one-C43418.svg": 2611,
	"./one/one-FEE12B.svg": 23962,
	"./one/one-FFFFFF.svg": 31826,
	"./seven/seven-000000.svg": 71918,
	"./seven/seven-36873E.svg": 29072,
	"./seven/seven-3E7DB5.svg": 27010,
	"./seven/seven-572509.svg": 47262,
	"./seven/seven-6F5374.svg": 98911,
	"./seven/seven-C43418.svg": 65847,
	"./seven/seven-FEE12B.svg": 2879,
	"./seven/seven-FFFFFF.svg": 56973,
	"./six/six-000000.svg": 5334,
	"./six/six-36873E.svg": 24251,
	"./six/six-3E7DB5.svg": 37751,
	"./six/six-572509.svg": 95924,
	"./six/six-6F5374.svg": 53639,
	"./six/six-C43418.svg": 75304,
	"./six/six-FEE12B.svg": 19874,
	"./six/six-FFFFFF.svg": 29666,
	"./star/star-000000.svg": 29940,
	"./star/star-36873E.svg": 76628,
	"./star/star-3E7DB5.svg": 2394,
	"./star/star-572509.svg": 114,
	"./star/star-6F5374.svg": 44600,
	"./star/star-C43418.svg": 96382,
	"./star/star-FEE12B.svg": 87254,
	"./star/star-FFFFFF.svg": 37697,
	"./three/three-000000.svg": 49611,
	"./three/three-36873E.svg": 54258,
	"./three/three-3E7DB5.svg": 26623,
	"./three/three-572509.svg": 54583,
	"./three/three-6F5374.svg": 33044,
	"./three/three-C43418.svg": 99546,
	"./three/three-FEE12B.svg": 2532,
	"./three/three-FFFFFF.svg": 98407,
	"./two/two-000000.svg": 63429,
	"./two/two-36873E.svg": 28012,
	"./two/two-3E7DB5.svg": 11699,
	"./two/two-572509.svg": 16745,
	"./two/two-6F5374.svg": 78541,
	"./two/two-C43418.svg": 49571,
	"./two/two-FEE12B.svg": 15023,
	"./two/two-FFFFFF.svg": 39988,
	"./yoga/yoga-000000.svg": 41091,
	"./yoga/yoga-36873E.svg": 23559,
	"./yoga/yoga-3E7DB5.svg": 33405,
	"./yoga/yoga-572509.svg": 22377,
	"./yoga/yoga-6F5374.svg": 60610,
	"./yoga/yoga-C43418.svg": 68002,
	"./yoga/yoga-FEE12B.svg": 15556,
	"./yoga/yoga-FFFFFF.svg": 98867,
	"./zero/zero-000000.svg": 1963,
	"./zero/zero-36873E.svg": 65605,
	"./zero/zero-3E7DB5.svg": 82467,
	"./zero/zero-572509.svg": 4565,
	"./zero/zero-6F5374.svg": 37652,
	"./zero/zero-C43418.svg": 39446,
	"./zero/zero-FEE12B.svg": 67442,
	"./zero/zero-FFFFFF.svg": 73653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22058;